const STEPS = [
  {
    number: "01",
    title: "Audit autonome (2-3 min)",
    description:
      "Vous saisissez votre URL et votre email. Notre agent IA audit@agents.levier-ia.fr exécute 7 sondes parallèles via Cloudflare Browser Run (performance, sécurité, RGPD, LLM-readiness, conversion, hygiène technique, tracking) en simulant les crawlers d'OpenAI et d'Anthropic. Vous recevez un rapport détaillé par email : findings priorisés, plan d'action, devis indicatif. Sans appel commercial.",
    highlight: true,
  },
  {
    number: "02",
    title: "Cadrage (15 min)",
    description:
      "Si l'audit vous parle, on cale un appel de 15 minutes pour valider le périmètre, les contenus à reprendre et le calendrier. Devis ferme sous 48 h.",
    highlight: false,
  },
  {
    number: "03",
    title: "Refonte (5 jours ouvrés)",
    description:
      "Design, intégration Astro/React, contenu SEO + GEO, schema markup, déploiement Cloudflare. Vous validez à mi-parcours et avant la mise en ligne.",
    highlight: false,
  },
  {
    number: "04",
    title: "Mise en ligne + 30 jours de support",
    description:
      "Bascule DNS, configuration Search Console et Bing Webmaster, soumission aux LLM crawlers. Support technique inclus 30 jours, formation à l'admin du site comprise.",
    highlight: false,
  },
];

export function Process() {
  return (
    <section id="process" className="py-24 px-6 bg-slate-900 border-t border-slate-800">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-3">
            Notre processus
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            De l'email à la mise en ligne en moins d'une semaine
          </h2>
          <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
            Un processus clair en 4 étapes. L'agent fait le diagnostic, l'équipe
            fondatrice de Levier IA fait 100 % du conseil et de la prod.
          </p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-blue-500/50 via-blue-500/20 to-transparent" />

          <div className="space-y-12">
            {STEPS.map((step, index) => (
              <div
                key={step.number}
                className={`relative flex items-start gap-8 ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
              >
                {/* Content */}
                <div
                  className={`flex-1 pl-20 md:pl-0 ${
                    index % 2 === 0 ? "md:text-right md:pr-12" : "md:text-left md:pl-12"
                  }`}
                >
                  <h3 className="text-xl font-semibold text-white mb-2 inline-flex items-center gap-2">
                    {step.title}
                    {step.highlight && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-blue-300 bg-blue-500/15 border border-blue-500/30 rounded-full">
                        Agent IA
                      </span>
                    )}
                  </h3>
                  <p className="text-slate-400 leading-relaxed">
                    {step.description.split(/(audit@agents\.levier-ia\.fr)/).map((part, i) =>
                      part === "audit@agents.levier-ia.fr" ? (
                        <code
                          key={i}
                          className="text-blue-300 font-mono text-sm bg-slate-800/60 px-1.5 py-0.5 rounded"
                        >
                          {part}
                        </code>
                      ) : (
                        <span key={i}>{part}</span>
                      ),
                    )}
                  </p>
                </div>

                {/* Number circle */}
                <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 flex items-center justify-center w-16 h-16">
                  <div
                    className={`w-10 h-10 rounded-full bg-slate-900 border-2 flex items-center justify-center transition-colors ${
                      step.highlight ? "border-blue-400 shadow-lg shadow-blue-500/30" : "border-blue-500"
                    }`}
                  >
                    <span className="text-sm font-bold text-blue-400">{step.number}</span>
                  </div>
                </div>

                {/* Spacer for opposite side */}
                <div className="hidden md:block flex-1" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
